import React, { useEffect, useState } from 'react';
import { Languages, Search, HelpCircle, Home, Heart, Star, Shield } from 'lucide-react';
import { categories, faqData } from '../components/faqs/faqsData';
import FAQList from '../components/faqs/FAQList';
import ContactCTA from '../components/faqs/ContactCTA';

const FAQsPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [language, setLanguage] = useState('english');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentFAQs = faqData[language];
  
  let filteredFAQs = currentFAQs;
  
  if (selectedCategory !== 'all') {
    filteredFAQs = filteredFAQs.filter(faq => faq.category === selectedCategory);
  }
  
  filteredFAQs = filteredFAQs.filter(faq =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getIconComponent = (iconName) => {
    const icons = {
      HelpCircle, Home, Heart, Star, Shield
    };
    return icons[iconName] || HelpCircle;
  };

  return (
    <div className=" relative overflow-hidden pb-20">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-0 w-80 h-80 bg-red-400/8 rounded-full blur-2xl"></div>
        <div className="absolute top-0 right-1/4 w-64 h-64 bg-red-300/6 rounded-full blur-xl"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-3 sm:px-6 md:px-12">
        
        <div className="mb-12 pt-8">
          <div className="text-center ">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extralight text-gray-900 mb-6 tracking-tight leading-tight">
              Have Questions?
              <span className="block text-[var(--primarycolor)] font-light">We're Here to Help.</span>
            </h2>
          </div>
        </div>

        {/* Language Toggle - Top Right */}
          <div className="mb-8 flex mx-auto w-fit items-center gap-1 sm:gap-2 bg-white/80 backdrop-blur-sm rounded-full p-1 border border-gray-200 shadow-sm">
            <button
              onClick={() => setLanguage('english')}
              className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-300 text-xs sm:text-sm ${
                language === 'english'
                  ? 'bg-[var(--primarycolor)] text-white shadow-md'
                  : 'text-gray-700 hover:bg-red-50'
              }`}
            >
              <Languages className="w-4 h-4" />
              English
            </button>
            <button
              onClick={() => setLanguage('malayalam')}
              className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-300 text-xs sm:text-sm ${
                language === 'malayalam'
                  ? 'bg-[var(--primarycolor)] text-white shadow-md'
                  : 'text-gray-700 hover:bg-red-50'
              }`}
            >
              <Languages className="w-4 h-4" />
              മലയാളം
            </button>
          </div>

        {/* Categories & Search */}
        <div className="space-y-6 mb-12">
          {/* Categories */}
          {/* <div className="flex flex-wrap items-center justify-center gap-1 sm:gap-3">
            {categories.map((category) => {
              const IconComponent = getIconComponent(category.icon);
              const isActive = selectedCategory === category.key;
              
              return (
                <button
                  key={category.key}
                  onClick={() => setSelectedCategory(category.key)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                    isActive
                      ? 'bg-red-600 text-white shadow-lg'
                      : 'bg-white text-gray-600 hover:bg-red-50 border border-gray-200'
                  }`}
                >
                  <IconComponent className="w-4 h-4" />
                  {category.label}
                </button>
              );
            })}
          </div> */}

          {/* Search */}
          <div className="flex justify-center">
            <div className="relative w-full max-w-md">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder={language === 'english' ? 'Search FAQs...' : 'FAQ-കൾ തിരയുക...'}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-2 sm:py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white shadow-sm"
              />
            </div>
          </div>
        </div>

        {/* FAQ Items */}
        <FAQList 
          faqs={filteredFAQs} 
          openIndex={openIndex} 
          toggleAccordion={toggleAccordion}
          language={language}
        />

        {/* Contact CTA */}
        <ContactCTA />
      </div>
    </div>
  );
};

export default FAQsPage;